// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-account-modal {
  display: flex;
  justify-content: center;
  background-color: rgba(31, 27, 250, 0.103);
  margin: 20px;
  margin-top: 5px;
  border-radius: 10px;
  padding: 10px;
}

.create-account-form-title {
  font-size: x-large;
  font-weight: bold;
  margin-bottom: 20px;
}

.create-account-form-description {
  font-size: x-large;
}

.create-account-form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.create-account-modal-claim-username-button {
  padding: 15px;
  background-color: rgba(31, 27, 250, 0.637);
  font-weight: bold;
  color: white;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 20px;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 10px;
}

.create-account-form-input-container {
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.create-account-modal-claim-username-button:hover {
  opacity: 0.8;
}

@media (max-width: 500px) {
  .create-account-form-title {
    font-size: large;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .create-account-form-description {
    font-size: large;
  }
}

.shameless-newsie-sub-checkbox {
  margin-top: 20px;
}

.create-account-modal img {
  width: 80px;
  height: 80px;
}

.create-account-login-button {
  background-color: rgba(170, 195, 219, 0.171);
  padding: 1%;
  margin: 10px;
  border-radius: 20px;
  border: rgb(27, 51, 129);
  border-width: 2px;
  border-style: solid;
  width: 100px;
}

.create-account-login-button:hover {
  background-color: rgba(170, 195, 219, 0.575);
  padding: 1%;
  margin: 10px;
  border-radius: 20px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Modal/modals/CreateAccount/CreateAccount.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".create-account-modal {\n  display: flex;\n  justify-content: center;\n  background-color: rgba(31, 27, 250, 0.103);\n  margin: 20px;\n  margin-top: 5px;\n  border-radius: 10px;\n  padding: 10px;\n}\n\n.create-account-form-title {\n  font-size: x-large;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.create-account-form-description {\n  font-size: x-large;\n}\n\n.create-account-form-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.create-account-modal-claim-username-button {\n  padding: 15px;\n  background-color: rgba(31, 27, 250, 0.637);\n  font-weight: bold;\n  color: white;\n  margin: auto;\n  margin-top: 10px;\n  margin-bottom: 20px;\n  width: fit-content;\n  border-radius: 10px;\n}\n\n.create-account-form-input-container {\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.create-account-modal-claim-username-button:hover {\n  opacity: 0.8;\n}\n\n@media (max-width: 500px) {\n  .create-account-form-title {\n    font-size: large;\n    font-weight: bold;\n    margin-bottom: 10px;\n  }\n  .create-account-form-description {\n    font-size: large;\n  }\n}\n\n.shameless-newsie-sub-checkbox {\n  margin-top: 20px;\n}\n\n.create-account-modal img {\n  width: 80px;\n  height: 80px;\n}\n\n.create-account-login-button {\n  background-color: rgba(170, 195, 219, 0.171);\n  padding: 1%;\n  margin: 10px;\n  border-radius: 20px;\n  border: rgb(27, 51, 129);\n  border-width: 2px;\n  border-style: solid;\n  width: 100px;\n}\n\n.create-account-login-button:hover {\n  background-color: rgba(170, 195, 219, 0.575);\n  padding: 1%;\n  margin: 10px;\n  border-radius: 20px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
